// extracted by mini-css-extract-plugin
export var notificationHost = "_ca-0";